import {Text} from '@eitje/web_components'
import {prettyPrintArray} from '@eitje/utils'

export const ArrayCell = ({getValue, value}) => {
	const arrayValue = getValue ? getValue() : value

	return <Text truncate t={prettyPrintArray({array: arrayValue, quotes: false, joinWord: '&', sort: true})} />
}
